import React from 'react';
import IconButton from 'componentes/common/IconButton.js';
import * as XLSX from 'xlsx';
import PropTypes from 'prop-types';

const BtnExportToExcell = ({ dataReport, fileName }) => {
  const downloadExcel = data => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, fileName + '.xlsx');
  };

  return (
    <>
      <IconButton
        variant="falcon-default"
        size="sm"
        icon="file-alt"
        transform="shrink-3"
        onClick={() => downloadExcel(dataReport)}
        //startIcon={<DownloadIcon fontSize="small" />}
        sx={{ mr: 1 }}
      >
        Exportar
      </IconButton>
    </>
  );
};
BtnExportToExcell.propTypes = {
  dataReport: PropTypes.array.isRequired,
  fileName: PropTypes.string.isRequired
};
export default BtnExportToExcell;
